import { useState } from 'react';

import type { BillingAddress } from './types';
import { parsePlaceAddress } from './utils';
import { FormFieldDefault } from 'src/common/FormField/FormFieldDefault';
import { FormFieldLocationTypeahead } from 'src/common/FormField/FormFieldLocationTypeahead';

interface BillingAddressFormProps {
  className?: string;
  onChange: (address: BillingAddress) => void;
  addressLookupPlaceholder?: string;
  value?: BillingAddress;
}

export function BillingAddressForm({
  className = 'grid grid-cols-1 gap-4',
  onChange,
  addressLookupPlaceholder,
  value,
}: BillingAddressFormProps) {
  const [address, setAddress] = useState<BillingAddress>({
    city: '',
    country: '',
    zip: '',
    state: '',
    street: '',
    street2: '',
    ...value,
  });

  return (
    <div className={className} data-testid="billing-address-form">
      <div>
        <FormFieldLocationTypeahead
          label="Address"
          inputProps={{
            id: 'billing-address-form-typeahead',
          }}
          onChange={(e) => {
            const address = parsePlaceAddress(e.label);
            setAddress(address);
            onChange(address);
          }}
          placeholder={addressLookupPlaceholder}
        />
      </div>
      <div>
        <FormFieldDefault
          type="text"
          label="Zip Code *"
          inputProps={{
            id: 'billing-address-form-zip',
            required: true,
            value: address.zip,
            onChange: (e) => {
              setAddress({ ...address, zip: e.target.value });
              onChange({ ...address, zip: e.target.value });
            },
          }}
          value={address.zip}
        />
      </div>
    </div>
  );
}
